module.exports = __webpack_public_path__ + "img/sample-file.173fdb48.svg";